import {useContext} from "react";
import {SessionContext} from "./SessionProvider";

export const useSession = (): any => {
    return useContext(SessionContext);
}
